export default "__VITE_ASSET__BxZNVK8N__"